import { isQuotingToolAvailable } from 'modules/common/permissions';

import { initDiscountDetailsPage } from './detailsPage/data/sagas';
import DiscountDetailsPage from './detailsPage/entry';
import { initDiscountsListPage } from './listPage/data/sagas';
import DiscountsListPage from './listPage/entry';

export default [
  {
    component: DiscountsListPage,
    exact: true,
    name: 'discountsListPage',
    path: '/processes/discounts',
    helpId: 'discounts_list',
    permissions: [isQuotingToolAvailable],
    saga: initDiscountsListPage,
  },
  {
    component: DiscountDetailsPage,
    exact: true,
    name: 'discountDetailsPage',
    path: '/processes/discounts/:discountId',
    helpId: 'discount_details',
    permissions: [isQuotingToolAvailable],
    saga: initDiscountDetailsPage,
  },
];
